import { POPOVER_CONTENT_OFFSET_Y } from '../../constants';
import { NavMenuPopoverProps } from '../../types';
import MenuContent from './MenuContentPopover';
import { StyledPopover } from './styles';

const NavMenuPopover = ({
  intl,
  menuId,
  subMenu,
  children,
  menuName,
  popoverDelay,
  activeRouteId,
  isLoading,
  isSubMenuVisible,
}: NavMenuPopoverProps) => (
  <StyledPopover
    placement="leftTop"
    align={{ offset: [0, POPOVER_CONTENT_OFFSET_Y] }}
    mouseEnterDelay={popoverDelay}
    content={
      <MenuContent
        subMenu={subMenu}
        menuName={menuName}
        menuId={menuId}
        intl={intl}
        activeRouteId={activeRouteId}
        isLoading={isLoading}
        isSubMenuVisible={isSubMenuVisible}
      />
    }
  >
    {children}
  </StyledPopover>
);

export default NavMenuPopover;
